import { render, staticRenderFns } from "./JoinClassMobile.vue?vue&type=template&id=3af62ed8&scoped=true"
import script from "./JoinClassMobile.vue?vue&type=script&lang=js"
export * from "./JoinClassMobile.vue?vue&type=script&lang=js"
import style0 from "./JoinClassMobile.vue?vue&type=style&index=0&id=3af62ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af62ed8",
  null
  
)

export default component.exports